import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const SearchBox = styled.div`
  display: flex;
  justify-content: center;
  background-color: rgb(196, 181, 114);
  padding: 20px;
  border: 2px solid rgb(177, 147, 14);
  border-radius: 5px;
`;

const Input = styled.input`
  padding: 10px;
  margin-right: 10px;
  font-size: 16px;
  color: #121211;
  background-color:rgb(227, 228, 223);
`;

const Button = styled.button`
  padding: 10px;
  font-size: 16px;
  cursor: pointer;
  background-color:rgb(211, 177, 23);
  border: 2px solid rgb(134, 114, 25);
  border-radius: 5px;
`;

const ProjectSearchBox = observer(() => {
  const [inputValue, setInputValue] = useState('');
  const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    history.push(`/${inputValue}`);
  };

  return (
    <>
      <SearchBox style={{ marginTop: '50px' }}>
        <form onSubmit={handleSubmit}>
          <Input
            type="text"
            value={inputValue}
            onChange={e => setInputValue(e.target.value)}
            placeholder="Enter Project Name"
          />
          <Button type="submit">Go</Button>
        </form>
      </SearchBox>
    </>
  );
});

export default ProjectSearchBox;
